import { Component, OnInit } from '@angular/core';
import { CommonUtilService } from '../service/common-util.service';
import { LargereceiptService } from '../service/largereceipt.service';

@Component({
  selector: 'app-receiptauthenticationsuccess',
  templateUrl: './receiptauthenticationsuccess.component.html',
  styleUrls: ['./receiptauthenticationsuccess.component.scss']
})
export class ReceiptauthenticationsuccessComponent implements OnInit {

  constructor(private largeReceiptService: LargereceiptService,private commonUtilSvc:CommonUtilService) { }

  ngOnInit(): void {
    this.commonUtilSvc.hideSpinner();
  }

}
